import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const LOGO =
  "https://customer-assets.emergentagent.com/job_website-rebuild-18/artifacts/6ecc2oy7_20251118_232018_0000.jpg";

const LoadingScreen = () => {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    return !sessionStorage.getItem("ap_loaded");
  });

  useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => {
      sessionStorage.setItem("ap_loaded", "1");
      setShow(false);
    }, 1800);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="splash"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          className="fixed inset-0 z-[100] flex items-center justify-center"
          style={{ background: "#1a1f2b" }}
          data-testid="splash-screen"
        >
          <div className="relative flex flex-col items-center">
            <motion.div
              initial={{ scale: 0.7, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="relative"
            >
              <div
                className="absolute inset-0 rounded-full blur-2xl"
                style={{
                  background: "rgba(224, 192, 104, 0.5)",
                  transform: "scale(1.4)",
                }}
              />
              <img
                src={LOGO}
                alt="AutoPilot"
                className="relative w-28 h-28 rounded-full border border-[rgba(224,192,104,0.6)] object-cover"
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.6 }}
              className="mt-8 tracking-[0.4em] text-[10px] uppercase"
              style={{ color: "#e0c068" }}
            >
              Drive like a pilot
            </motion.div>

            <motion.div
              initial={{ width: 0 }}
              animate={{ width: 160 }}
              transition={{ delay: 0.7, duration: 0.9, ease: "easeInOut" }}
              className="mt-5 h-px"
              style={{
                background:
                  "linear-gradient(90deg, transparent, #e0c068, transparent)",
              }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LoadingScreen;
